export default [
  {
    path: "/privilege",
    name: "privilege",
    meta: {
      title: "特权启动教程",
    },
    component: () => import("./PrivilegeTutorial"),
  },
  {
    path: '/bind/process',
    name: 'bind.process',
    meta: {
      title: '绑定流程'
    },
    component: () => import("./BindProcess"),
  }
];
